import React from 'react';
import ReactDOM from 'react-dom';
import Microsite from './Microsite';

ReactDOM.render(
  <Microsite/>,
  document.getElementById('root')
);
